module.exports = __webpack_public_path__ + "img/emoticon-nps-6-on.16c7a063.svg";